import { useContext, useRef } from 'react';

import '@/style/UI.css';
import { useNavigate } from 'react-router-dom';

import losing_horn_sfx from '@/assets/music/losing_horn_price_is_right.mp3';
import victory_fanfare_sfx from '@/assets/music/victory_fanfare_scott_pilgrim.mp3';
import ssb_success_sfx from '@/assets/sound_effects/ssb_success.mp3';
import { GameContext } from '@/state/contexts';
import { getRandomArrayIndex } from '@lc/lib/array';

const EndgameDisplay = () => {
	const { myState, gameStatus, playerStateArray }: any =
		useContext(GameContext);

	const audioLoseRef: any = useRef(new Audio(losing_horn_sfx));
	const audioSuccessRef: any = useRef(new Audio(ssb_success_sfx));
	const audioVictoryRef: any = useRef(new Audio(victory_fanfare_sfx));

	audioLoseRef.current.loop = false;
	audioLoseRef.current.volume = 0.5;

	audioSuccessRef.current.loop = false;
	audioSuccessRef.current.volume = 0.75;

	audioVictoryRef.current.loop = false;
	audioVictoryRef.current.volume = 0.5;

	const navigate = useNavigate();

	function navHome(e) {
		e.preventDefault();
		navigate('/', { replace: true });
	}

	function getColor(color: string) {
		if (color === 'yellow') {
			return '#f6de9a';
		} else if (color === 'blue') {
			return '#15bedb';
		} else if (color === 'red') {
			return '#efa1ae';
		} else if (color === 'green') {
			return '#556341';
		} else if (color === 'fail') {
			return '#fb2d01';
		}

		return 'white';
	}

	const goodEndTexts = [
		`Celebrate good times`,
		`I'm a big fan`,
		`The sun will come out tomorrow`,
		`You make one mean root square`,
		`Color me shocked`,
		`Near, far, wherever you solar`,
		`And they lived happily ever after`,
	];

	const badEndTexts = [
		'Better luck next time',
		'The world has ended thanks to you',
		'Maybe be a little less greedy next time',
		`It's a crude world`,
		`Really scraping the bottom of the barrel`,
		`Out with a bang`,
		`What the frack`,
		`Runnin' on empty`,
	];

	function randomElement(array: string[]) {
		const randomIndex = getRandomArrayIndex(array);
		return array[randomIndex];
	}

	function playAudioOnce(audio: any) {
		if (audio.paused || audio.ended) {
			audio.currentTime = 0;
			audio.volume = 1;
			audio.play().catch(console.error);
		} else {
			// Audio is already playing, do nothing
			console.log('Audio already playing, skipping.');
		}
	}

	const EndgameEffects = () => {
		let array: string[] = badEndTexts;
		if (gameStatus === 1) {
			playAudioOnce(audioLoseRef.current);
		} else {
			playAudioOnce(audioSuccessRef.current);
			setTimeout(() => {
				playAudioOnce(audioVictoryRef.current);
			}, 2000);

			array = goodEndTexts;
		}

		return (
			<h2>
				{randomElement(array)}, {myState.username}
			</h2>
		);
	};

	return (
		<div className="endgameTextContainer">
			{gameStatus === 1 ? <h1>YOU LOSE 😔</h1> : <h1>YOU WIN 🥳</h1>}
			{gameStatus === 1 && <EndgameEffects />}
			{gameStatus === 2 && <EndgameEffects />}
			<ul>
				{playerStateArray.map((p) => {
					return (
						<li>
							<span style={{ color: getColor(p.color) }}>
								{p.username} (Player {p.playerId}) donated{' '}
								{p.totalDonation} energy
							</span>
						</li>
					);
				})}
			</ul>
			<button onClick={(e) => navHome(e)}>Navigate Home</button>
		</div>
	);
};

export default EndgameDisplay;
